// extracted by mini-css-extract-plugin
export default {"overviewContainer":"participantsOverview_overviewContainer__dTf7X","overviewBlock":"participantsOverview_overviewBlock__JqVLT"};